import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  name: string;
  rate: number | null;
};

export const useSchemaRoles = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingPositions = projectData.positions
    .map((position) => position.name?.toLocaleLowerCase())
    .filter((position) => position !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingPositions, t('addRoles.existing'))
          .max(250),
        rate: Yup.number().nullable().required(),
      }),
    [t, existingPositions],
  );
};
